export const defaultTheme = {
  fonts: {
    title: "Space Grotesk, sans-serif",
    main: "Space Grotesk, sans-serif",
  },

  colors: {
    primary: "rgb(30, 30, 30)",
    primaryTransparent: "rgb(30, 30, 30, 0.7)",
    secondary: "rgb(100, 150, 215)",
    backgroundPrimary: "rgb(252, 251, 252)",
    accent: "rgb(255, 195, 120)",
    button: "rgb(0, 110, 185)",
    backgroundSecondary: "rgb(45, 50, 75)",
    shadow: "rgb(0, 0, 0, 0.3)",
  },

  breakpoints: {
    xslandscape: "screen and (max-height: 320px)",
    smlandscape: "screen and (max-height: 480px)",
    xs: "screen and (max-width: 320px)",
    sm: "screen and (max-width: 640px)",
    md: "screen and (max-width: 768px)",
    lg: "screen and (max-width: 1024px)",
    xl: "screen and (max-width: 1280px)",
  },
};
